/*pope
 *in this module there are all the functions to create
 *  - the popup for TRO
 *  - the popup for FRA
 *  - the popup for FRA staff
 *  - the popup for PSA
 *  - the popup for PSA staff
 *  - hover popup
 *  - display the correct popup (TRO(inside we check which one like client, fra, psa), PC or hover)
 *  - the PC comment popup has it's own module, however it's calls in this file
 *  - the fra staff buttons in the popup also have their own module that it's calls in this file
 */

/**
 * import modules
 */

import functions from '../common/functions'
import pccomment from './pccomments'
import frabutton from '../frastaff/popup_buttons'
import psabutton from '../psastaff/popup_buttons'
var pageconfig = JSON.parse($('#pageconfig').val())
let popupconfig = JSON.parse($('#popupconfig').val())
let appname = pageconfig.appname.type
let docpath = $('#docstore').val() + '/documents/parkmap/'
let lang = $('#dropdownLangButton').attr('data-code')
if (lang === '' || lang === null || typeof lang === 'undefined') {lang = 'en'}
let restrObjected = ''
let pm_id = 0
let gXML

var coord
var coordClick
var today = new Date()
var dd = String(today.getDate()).padStart(2, '0')
var mm = String(today.getMonth() + 1).padStart(2, '0')
var yyyy = today.getFullYear()
today = dd + '-' + mm + '-' + yyyy


let schemeObjected = ''
let streetObjected = 'N/A'
/**
 * nottingham
 * functions to create the list of buttons at the end of the popup
 */

/**
 * get the exemptions list
 */

let twExemptions

const getExemptions = () => {
  /**
   * get the json file
   */

  $.ajax({
    url: docpath + 'excodes.json',
    dataType: 'json',
    async: false
  })
    .done((data) => {
      /**
       * assing to twExemptions the data.exemptions
       */

      twExemptions = data.exemptions
    })
    .fail((jqxhr, textStatus, error) => {
      const err = `${textStatus} , ${error}`
      alert(`json for excodes Request Failed: ${err}`)
    })
}

/**
 * build the Exemptions list
 * we need to pass the codeList, sInfoDiv, authority
 */

const buildExemptions = (codeList, sInfoDiv, authority) => {
  /**
   * split the whole list by ,
   * assing blank to exDiv and sdecode
   */

  let exList = codeList.split(',')
  let exBtn = ''
  let sdecode = ''

  for (let j = 0; j <= (exList.length - 1); j++) {
    /**
     * remove the whitespace from the beginning and end of the exList code
     * decode the excode
     */

    exList[j] = $.trim(exList[j])
    sdecode = decodeExemption(exList[j], authority)

    /**
     * check the decoded value from the previous function
     * if there is a result:
     *  - create a button
     *  - apply the value of the decode var to it
     *  - add the name of the exlist code
     * if is empty:
     *  - create a span
     *  - add the name of the exlist code
     */

    if (sdecode !== '') {
      exBtn += `<button id='exbtn_${sInfoDiv}' class='custbtn exCodeBtn' value= '${sdecode}'>${exList[j]}</button>`
    }
    else {
      exBtn += `<span class='excode'>${exList[j]}</span>`
    }
  }
  /**
   * return the exBtn
   */

  return exBtn
}

/**
 * decode the exemptions code
 * we need to pass the exemption code and the authority
 */

const decodeExemption = (theCode, authority) => {
  /**
   * assign blank to ldecode
   */

  let ldecode = ''

  /**
   * iterate through the twExemptions list
   */

  for (let h = 0; h <= (twExemptions.length - 1); h++) {
    /**
     * check if the twExemptions.code and the twExemptions.authority match
     * assing the twExemptions.desc to ldecode
     */

    if (twExemptions[h].code === theCode && twExemptions[h].authority === parseInt(authority)) {
      ldecode = twExemptions[h].desc
    }
  }
  /**
   * return ldecode
   */

  return ldecode
}

/**
 * build the popup content
 * full popup for TRO
 * we need to pass xml, mousePos, overlay
 */

const fullInfo = (xml, mousePos, getOverlay,view ) => {
  /**
   * assign the popupname value
   * assign the overlay value
   */
  let layerinfo = functions.altFind(pageconfig.layers, function(e) {return e.layers === "parkmap"})
  let popupname = layerinfo.popupname
  let overlay = getOverlay
  coordClick = mousePos


  // if nottingham get exemption codes

  if (popupname === 'nottingham') {
    getExemptions()
  }
  /**
   * get the result from the XML
   * - create a parser
   * - parse the result
   * - get the item element
   * - get the length of the item element
   */

   let myitems = xml.getElementsByTagName('item')
   let myitemsLength = myitems.length

  /**
   * initilaize some variable to use it in the process
   */

  let conterz = ''
  let infolink = ''
  let infoDiv = ''

  /**
   * get the popup container
   *  - normal popup
   *  - mobile popup
   */

  let content = document.getElementById('popup-content')
  let modalpop = document.getElementById('mobpopupbody')

  /**
   * other variables used in the process
   */

  var btext
  var dfrom
  var dto
  var sSignFile
  var iGif
  var iPdf
  var infoms = ''

  /**
   * if there is no result or is a moving sign return
   */

  if (myitems.length === 0 || myitems[0].attributes.getNamedItem('type').nodeValue === 'movingSign') {
    return
  }

  /**
   * create the popup content
   */

  /**
   * check if it's a FRA website
   */

  if ((appname === 'fra' || appname === 'psa') && !pageconfig.private) {
    /**
     * iterate through the result
     */
    for (let i = 0; i <= (myitemsLength - 1); i++) {
      /**
       * check if the node is Confirmed
       */

      /**
       * check if the node is FRA
       */

      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'fra') {
        /**
         * check if the node is Confirmed
         */

        if (myitemsLength > 1) {
          /**
           * add the restriction name and the street name to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'fref')}</li>`
        }

        /**
         * append the Fra ref
         */

        conterz += `<span id='Ref${i}' class='infotitle'>${popupconfig.fra_popup.ref}<span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'fref')}</span></span><br>`

        /**
         * get the fstatus
         * convert the fstatus to the correct status
         */

        let iStatus = parseInt(functions.getFieldValue(myitems, i, 'fstatus'))
        let stmp = ''

        if (iStatus === 1) {
          stmp = popupconfig.fra_popup.pending
        }
        else if (iStatus === 2) {
          stmp = popupconfig.fra_popup.complete
        }
        else if (iStatus === 3) {
          stmp = popupconfig.fra_popup.expired
        }

        /**
         * append the correct status
         */

        conterz += `<span id='Status${i}' class='infotitle'>${popupconfig.fra_popup.status}<span class='infotitle_norm'>${stmp}</span></span><br>`

        /**
         * get the timestamp
         * change the format of the date
         * append the correct date
         * append the fcomment field
         */

        let tstamp = (myitems[i].getElementsByTagName('tstamp')[0].firstChild.nodeValue).split(' ')
        tstamp = `${tstamp[0].split('-').reverse().join('/')} ${tstamp[1]}`

        conterz += `<span id='tstamp${i}' class='infotitle'>${popupconfig.fra_popup.logdate}<span class='infotitle_norm'>${tstamp}</span></span><br>`
        conterz += `<span id='Comment${i}' class='infotitle'>${popupconfig.fra_popup.comment}<span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'fcomment')}</span></span>`

        /**
         * check if the node is photo
         */
        if (functions.getFieldValue(myitems, i, 'photo') && functions.getFieldValue(myitems, i, 'photo') !== '') {
          let photo = '/documents/fra/' + encodeURIComponent(functions.getFieldValue(myitems, i, 'photo'))
          conterz += `<span id='Photo${i}' class='popPhoto'><a href="${$('#docstore').val()}${photo}" target='_blank' rel='noopener noreferrer'><img src="${$('#docstore').val()}${photo}" onerror="this.style.display='none'"></a></span>`
        }
      } else {
        // PARKMAP FEATURE
            /**
                 * check if the length of the result is more than 1
                 */
            if (myitemsLength > 1) {
                if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
                infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'polyname')}</li>`
                }  else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
                infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`
                } else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'streetlight') {
                    infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'zonename')}</li>`

                } else {
                if (lang !== 'en') {
                    infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction_ln')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
                } else {
                    infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
                }
                }
            }
            /**
             * append the order_ref
             * append the restriction name
             * append the street name
             */
             if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
                /**
                 * if it's a confirmed order
                 */
                 conterz += `<div class='infotitle'><span class='accsize'>${functions.getFieldValue(myitems, i, 'polyname')}</span></div>`
                }
                else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
                  /**
                   * check if the length of the result is more than 1
                   */
                    infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`
                    conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'property')}</span></div>`
                    conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'street')}</span></div>`
                    infoms = ''
                } else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'streetlight') {
                        conterz += `<span class='infotitle'>Area: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('zonename')[0].firstChild.nodeValue}</span></span><span class='infotitle'> Speed: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('speed')[0].firstChild.nodeValue}</span></span>`
                        conterz += `<div><span>${popupconfig.consult_popup.datastate} (<time>${functions.getPublishDate(pageconfig.appname.type)}<time>)</span></div>`

                } else {

                    conterz += `<span id='Ref${i}' class='infotitle'>${functions.getFieldValue(myitems, i, 'order_ref')}</span><br>`
                    if (lang !== 'en') {
                    conterz += `<span class='Type${i}'>${functions.getFieldValue(myitems, i, 'restriction_ln')}</span><br>`
                    } else {
                    conterz += `<span class='Type${i}'>${functions.getFieldValue(myitems, i, 'restriction')}</span><br>`
                    }

                    conterz += `<span class='Type${i}'>${functions.getFieldValue(myitems, i, 'street_name')}</span>`
                }
      }

      /**
       * check if is the first iteration, first result or not
       * append the correct div to the popup content
       */

      if (i === 0) {
        infoDiv = infoDiv + `<div id='info_${i}' class='info-panel'>${conterz}</div>`
      }
      else {
        infoDiv = infoDiv + `<div id='info_${i}' class='info-panel' style='display:none;'>${conterz}</div>`
      }

      /**
       * reset the conterz var as now is inside the infoDiv var
       */

      conterz = ''
    } // next feature
  }

  /**
   * check if it's a FRA PSA staff website
   */

  else if ((appname === 'fra' || appname === 'psa') && pageconfig.private) {
    /**
     * iterate through the result
     */

    for (let i = 0; i <= (myitemsLength - 1); i++) {
      /**
       * check if the node is fra
       */

      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'fra') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the restriction name and the fref to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.fra_popup.faultref}${functions.getFieldValue(myitems, i, 'fref')}</li>`
        }

        /**
         * get the status save it in a variable
         * get the action save it in a variable
         * modify the action if it's empty
         */
        let status = functions.getFieldValue(myitems, i, 'fstatus')
        let action = functions.getFieldValue(myitems, i, 'faction')

        if (action === '') {
          action = popupconfig.fra_popup.actionprompt
        }

        /**
         * get the exp date and change the date format
         * get the date stamp and change the date format
         * get the date stamp and split it by space
         */

        let expdate = (myitems[i].getElementsByTagName('expdate')[0].firstChild.nodeValue).split('-').reverse().join('/')
        let datimstamp = (myitems[i].getElementsByTagName('tstamp')[0].firstChild.nodeValue).split(' ')
        datimstamp = `${datimstamp[0].split('-').reverse().join('/')} ${datimstamp[1]}`

        let dstamp = functions.getFieldValue(myitems, i, 'tstamp').split(' ')

        /**
         * add the fref field
         * add the expdate var
         * add the datimstamp var
         * add the fcomment field
         */

        conterz += `<div><span class='infotitle'>${popupconfig.fra_popup.ref}</span><span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'fref')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.fra_popup.expiry}</span><span class='infotitle_norm'>${expdate}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.fra_popup.logtime}</span><span class='infotitle_norm'>${datimstamp}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.fra_popup.comment}</span><span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'fcomment')}</span></div>`

        /**
         * check if the node photo is not empty
         * check if it's a dev environment or live
         * append the photo to the popup
         */

        if (functions.getFieldValue(myitems, i, 'photo')) {
            let photo = '/documents/fra/' + encodeURIComponent(functions.getFieldValue(myitems, i, 'photo'))
            conterz += `<span id='Photo${i}' class='popPhoto'><a href='${$('#docstore').val()}${photo}' target='_blank' rel='noopener noreferrer'><img class="fraimg" src='${$('#docstore').val()}${photo}' onerror="this.style.display='none'"></a></span>`
        }

        /**
         * append the Action text plus the button to edit
         * append the action field
         */

        conterz += `<div><span class='infotitle'>${popupconfig.fra_popup.action}</span><button id='${functions.getFieldValue(myitems, i, 'fref')}__${functions.getFieldValue(myitems, i, 'fstatus')}__${dstamp}__${action}' class='edit-action custbtn fas fa-pencil'></button></div>`
        conterz += `<div class='actiondiv'><span class='action' id='action_${i}'>${action}</span></div>`

        /**
         * append a spacer
         */
        conterz += `<div class='spacer'></div>`

        /**
         * append the correct list of buttons
         */
        conterz += `<fieldset class="groupbox-border"><legend class="groupbox-border">Status</legend><div id='stat_${i}' class='togle'>`
        if (status === '1') {
          conterz += `<input type="radio" id="pending" name="radio" value="1" checked><label class="fralabel" for="pending">${popupconfig.fra_popup.pending}</label><br>`
          conterz += `<input type="radio" id="complete" name="radio" value="2"><label class="fralabel" for="complete">${popupconfig.fra_popup.complete}</label><br>`
          conterz += `<input type="radio" id="expired" name="radio" value="3"><label class="fralabel" for="expired">${popupconfig.fra_popup.expired}</label>`
        }
        if (status === '2') {
            conterz += `<input type="radio" id="pending" name="radio" value="1" ><label class="fralabel" for="pending">${popupconfig.fra_popup.pending}</label><br>`
            conterz += `<input type="radio" id="complete" name="radio" value="2" checked><label class="fralabel" for="complete">${popupconfig.fra_popup.complete}</label><br>`
            conterz += `<input type="radio" id="expired" name="radio" value="3"><label class="fralabel" for="expired">${popupconfig.fra_popup.expired}</label>`

        }
        if (status === '3') {
            conterz += `<input type="radio" id="pending" name="radio" value="1"><label class="fralabel" for="pending">${popupconfig.fra_popup.pending}</label><br>`
            conterz += `<input type="radio" id="complete" name="radio" value="2"><label class="fralabel" for="complete">${popupconfig.fra_popup.complete}</label><br>`
            conterz += `<input type="radio" id="expired" name="radio" value="3" checked><label class="fralabel" for="expired">${popupconfig.fra_popup.expired}</label>`

        }
        conterz += `</div></fieldset>`
        /**
         * append the delete button
         * append the update button
         */

        conterz += `<button id='${functions.getFieldValue(myitems, i, 'fref')}_${dstamp}' class='custbtn delete fraDelete'>${popupconfig.fra_popup.delete}</button>`
        conterz += `<button class='custbtn save fraSave' id='${functions.getFieldValue(myitems, i, 'fref')}_${functions.getFieldValue(myitems, i, 'fstatus')}_${dstamp}_${action}'>${popupconfig.fra_popup.save}</button>`

        /**
         * end fra popup
         */
      }

      /**
       * check if the node is psa
       */

      else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'psa') {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the restriction name and the suspid to infolink
           * this will be use in the list that display all the selected restrictions
           */

          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${popupconfig.psa_popup.application}${functions.getFieldValue(myitems, i, 'suspid')}</li>`
        }

        /**
         * get the exp date and change the date format
         * get the date stamp and change the date format
         * get the date stamp and split it by space
         */

        let dexpdate = (myitems[i].getElementsByTagName('expdate')[0].firstChild.nodeValue).split('-').reverse().join('/')
        let datimstamp = (myitems[i].getElementsByTagName('tstamp')[0].firstChild.nodeValue).split(' ')
        datimstamp = `${datimstamp[0].split('-').reverse().join('/')} ${datimstamp[1].split('.')[0]}`

        let dstamp = functions.getFieldValue(myitems, i, 'tstamp').split(' ')

        /**
         * add the suspid field
         * add the expdate var
         * add the datimstamp var
         */

        conterz += `<div><span class='infotitle'>${popupconfig.psa_popup.id}</span><span class='infotitle_norm'>${functions.getFieldValue(myitems, i, 'suspid')}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.psa_popup.expiry}</span><span class='infotitle_norm'>${dexpdate}</span></div>`
        conterz += `<div><span class='infotitle'>${popupconfig.psa_popup.logtime}</span><span class='infotitle_norm'>${datimstamp}</span></div>`

        /**
         * append the delete button
         */

        conterz += `<br /><button id='${functions.getFieldValue(myitems, i, 'suspid')}_${dstamp}' class='custbtn psadelbtn'>${popupconfig.psa_popup.delete}</button>`

        /**
         * end psa popup
         */
      }

      /**
       * else if it's a parkmap popup
       */

      else {
        /**
         * check if the length of the result is more than 1
         */

    /**
     * check if the length of the result is more than 1
     */

     if (myitemsLength > 1) {
        if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'polyname')}</li>`
        }  else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`

        } else {
          if (lang !== 'en') {
            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction_ln')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
          } else {
            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
          }
         }
      }


      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
        /**
         * if it's a confirmed order
         */

         conterz += `<div class='infotitle'><span class='accsize'>${functions.getFieldValue(myitems, i, 'polyname')}</span></div>`
        }
        else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
          /**
           * check if the length of the result is more than 1
           */
            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`
            conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'property')}</span></div>`
            conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'street')}</span></div>`
            infoms = ''
        } else {
        /**
         * append the order_ref field
         * append the street_name field
         * append the restriction field
         */

        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'order_ref')}&nbsp</span>`
        conterz += `<span class='street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`

        if (lang !== 'en') {
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'restriction_ln')}</span></div>`
        } else {
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'restriction')}</span></div>`
        }
        /**
       * store the ms_grid and order_ref in a hidden input
       * create the titles
       */
        conterz += `<div>Tariff:<span>${functions.getFieldValue(myitems, i, 'tariff') + functions.getFieldValue(myitems, i, 'tariff1') + functions.getFieldValue(myitems, i, 'tariff2')}</span></div>`

        conterz += `<input id='msgrid_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'ms_grid')}'/>`
        conterz += `<input id='orderref_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'order_ref')}'/>`
        // add hidden entry_type to check for geom
        conterz += `<input id='entry_type_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'entry_type')}'/>`
        /**
         * append a spacer
         */

        conterz += `<div class='spacer'></div>`

        /**
         * append the ordstart and ordfinish field
         * append a spacer
         */

        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'ordstart')} ${functions.getFieldValue(myitems, i, 'ordfinish')}</span></div>`
        conterz += `<div class='spacer'></div>`

        /**
         * get the date_from
         * get the date_to
         */

        dfrom = (myitems[i].getElementsByTagName('date_from')[0].firstChild.nodeValue).split('-').reverse().join('/')
        dto = (myitems[i].getElementsByTagName('date_to')[0].firstChild.nodeValue).split('-').reverse().join('/')

        /**
         * check the date_to date
         * append the correct text
         */

        if (dto !== undefined && dto !== '01/01/2199' && dto !== '') {
          conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.dateto}${dto}</span></div>`
        }
        else {
          conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.presentday}</span></div>`
        }

        /**
         * check if the district field is not empty
         * append the correct text
         */

        if (myitems[i].getElementsByTagName('district')[0].childNodes.length !== 0) {
          conterz += `<div><span class='street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}, ${functions.getFieldValue(myitems, i, 'district')}</span></div>`
        }
        else {
          conterz += `<div class='accsize' style='width:260px;'><span class='accsize street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
        }

        /**
         * append the Data correct at time of publication text
         */

        conterz += `<div class='accsize'><span class='accsize'>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)})</span></div>`

        /**
         * check if blockimagefile it's not empty
         * append the correct text
         */

        if (myitems[i].getElementsByTagName('blockimagefile')[0].childNodes.length !== 0) {
          sSignFile = functions.getFieldValue(myitems, i, 'blockimagefile')
          iGif = -1
          iPdf = -1
          iGif = sSignFile.indexOf('.gif')
          iPdf = sSignFile.indexOf('.pdf')

          if (iGif !== -1) {
              conterz += `<div><img src='${docpath}signs/${sSignFile}'/></div>`
          }
          if (iPdf !== -1) {
            conterz += `<div><a href='${docpath}signs/${sSignFile}' target=_blank  rel='noopener noreferrer'>View pdf</a></div>`
          }
        }

        infoms = `<div style='display:none' id='docstore_${i}'><button class='infobutt custbtn' id='docbutton_${i}'>View Documents...</button><div id='docdiv_${i}' style='display:none'></div></div>`
    }
        /**
         * end parkmap popup
         */
      }

      /**
       * copy button
       */

      conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="Copy content to clipboard"></button>`

        /**
         * check if is the first iteration, first result or not
         * append the correct div to the popup content
         */

         if (i === 0) {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel'>${infoms}${conterz}</div>`
        }
        else {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel' style='display:none;'>${infoms}${conterz}</div>`
        }
        /**
         * reset the conterz var as now is inside the infoDiv var
         */

        conterz = ''
    } // next feature

    /**
     * end if app === fra_staf or psa_staff
     */
  }

  /**
   * else if it's a parkmap popup
   */

  else {
    /**
     * nottingham popup
     */

    if (popupname === 'nottingham') {
      /**
       * iterate through the result
       */

      for (let i = 0; i <= (myitemsLength - 1); i++) {
        /**
         * check if the node is Confirmed
         */

        if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Confirmed') {
          /**
           * check if the length of the result is more than 1
           */

          if (myitemsLength > 1) {
            /**
             * add the restriction name and the street name to infolink
             * this will be use in the list that display all the selected restrictions
             */

            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
          }

            /**
             * get the additonalinfo value
             * append it to the popup content
             */

            if (parseInt($('#addinfo').val()) > 0) {
                conterz = conterz + `<div><a class='infobutt custbtn' target='_blank' rel='noopener noreferrer' href='/additionalinformation/${pageconfig.config_id}/${functions.getFieldValue(myitems, i, 'authority')}'>${popupconfig.parkmap_popup.addinfo}</a></div>`
            }

          /**
           * store the ms_grid and order_ref in a hidden input
           * create the titles
           */

          conterz += `<input id='msgrid_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'ms_grid')}'/>`
          conterz += `<input id='orderref_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'order_ref')}'/>`
          // add hidden entry_type to check for geom
          conterz += `<input id='entry_type_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'entry_type')}'/>`


          conterz += `<div class='infotitle infotab'><span>${functions.getFieldValue(myitems, i, 'order_ref')}&nbsp</span>`
          if (functions.getFieldValue(myitems, i, 'street_name').toLowerCase().indexOf('zone') >= -1) {
            conterz += `<span class='custflotitle'>${popupconfig.parkmap_popup.street}${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
          } else {
            conterz += `<span class='custflotitle street_name_${i}'>${popupconfig.parkmap_popup.street}${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
          }
          

          /**
           * check if the node is Controlled Parking Zones
           * append fixed text
           */

          if (functions.getFieldValue(myitems, i, 'order_type') === 'Controlled Parking Zones') {
            conterz += `<div><span class='infotitle'>${popupconfig.parkmap_popup.cpz}</span></div>`
          }

          /**
           * append the restriction name and a space
           */

          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'restriction')}</span></div>`
          conterz += `<div class='spacer'></div>`

          /**
           * check if the restriction is a region or a type
           */

          if (functions.getFieldValue(myitems, i, 'entry_type') === 'Region' || functions.getFieldValue(myitems, i, 'entry_type') === 'Point') {
            /**
             * append the ordlocation
             */

            if (functions.getFieldValue(myitems, i, 'ordlocation') !== '') {
              conterz += `<div><span>${functions.getFieldValue(myitems, i, 'ordlocation')}</span></div>`
            }
          }
          /**
           * if is a line restriction
           */

          else {
            /**
             * check the ordstart value
             * if is not empty append the ordstart and ordfinish value
             */

            if (functions.getFieldValue(myitems, i, 'ordstart') !== '') {
              conterz += `<div><span>${functions.getFieldValue(myitems, i, 'ordstart')} ${functions.getFieldValue(myitems, i, 'ordfinish')}</span></div>`
            }
          }

          /**
           * get the from/to date
           * append the correct text
           */

          dfrom = (myitems[i].getElementsByTagName('date_from')[0].firstChild.nodeValue).split('-').reverse().join('/')
          dto = (myitems[i].getElementsByTagName('date_to')[0].firstChild.nodeValue).split('-').reverse().join('/')

          if (dto !== undefined && dto !== '01/01/2199' && dto !== '') {
            conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.dateto}${dto}</span></div>`
          }
          else {
            conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.presentday}</span></div>`
          }

          /**
           * check if the district field is not empty
           * append the correct text
           */

          if (myitems[i].getElementsByTagName('district')[0].childNodes.length !== 0) {
            conterz += `<div><span class='street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}, ${functions.getFieldValue(myitems, i, 'district')}</span></div>`
          }
          else {
            conterz += `<div><span class='street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
          }

          /**
           * append a newline
           */

          conterz += '<br />'

          /**
           * check the times_of_enforcement field
           */

          if (myitems[i].getElementsByTagName('times_of_enforcement')[0].childNodes.length !== 0) {
            /**
             * create the exemptions list
             * append it to the popup content
             */

            let tExemp = buildExemptions(functions.getFieldValue(myitems, i, 'times_of_enforcement'), i, functions.getFieldValue(myitems, i, 'authority'))
            conterz += `<div><span class='infotitle exemtitle'>${popupconfig.parkmap_popup.exemptions}</span><div class='tExempDiv'>${tExemp}</div><p id='exDesc_${i}' oldval='none' style='width:100%; display:none;'></p></div>`
          }

          /**
           * check the pre_description field
           * append the correct text
           */

          if (myitems[i].getElementsByTagName('pre_description')[0].childNodes.length !== 0) {
            conterz += `<div><span class='infotitle'>${popupconfig.parkmap_popup.permitarea}</span><span>${functions.getFieldValue(myitems, i, 'pre_description')}</span></div>`
          }

          /**
           * check the post_description field
           * append the correct text
           */

          if (myitems[i].getElementsByTagName('post_description')[0].childNodes.length !== 0) {
            conterz += `<div><span class='infotitle'>${popupconfig.parkmap_popup.zone}</span><span>${functions.getFieldValue(myitems, i, 'post_description')}</span></div>`
          }

          /**
           * append the Data correct at time of publication (date) text
           */

          conterz += `<div><span>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)})</span></div>`

          /**
           * check the blockimagefile field
           */

          if (myitems[i].getElementsByTagName('blockimagefile')[0].childNodes.length !== 0) {
            /**
             * get the blockimagefile value
             * check for the presence of gif or pdf in the name
             * append the correct text
             */

            sSignFile = functions.getFieldValue(myitems, i, 'blockimagefile')
            iGif = -1
            iPdf = -1
            iGif = sSignFile.indexOf('.gif')
            iPdf = sSignFile.indexOf('.pdf')

            if (iGif !== -1) {
              conterz += `<div><img src='${docpath}signs/${sSignFile}'/></div>`
          }
          if (iPdf !== -1) {
            conterz += `<div><a href='${docpath}signs/${sSignFile}' target=_blank  rel='noopener noreferrer'>${popupconfig.parkmap_popup.pdf}</a></div>`
          }
          }

          /**
           * append the view documents button
           * it will be populate at the end of the function
           */

          infoms = `<div style='display:none' id='docstore_${i}'><button class='infobutt custbtn'  id='docbutton_${i}'>${popupconfig.parkmap_popup.viewdocuments}</button><div id='docdiv_${i}' style='display:none'></div></div>`

          /**
           * end if Confirmed node
           */
        }
        /**
         * check if the node is tariff zones or parking zones
         */

        else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones') {
          /**
           * check if the length of the result is more than 1
           */

          if (myitemsLength > 1) {
            /**
             * add the polygon name to infolink
             * this will be use in the list that display all the selected restrictions
             */

            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'polyname')}</li>`
          }

          /**
           * append the polygon name
           * append the polygon info
           * tariff rates and charges
           * NOTTIGNHAM ONLY
           */
          if (functions.getFieldValue(myitems, i, 'order_doc') !== '') {
            conterz += `<div><a href='${docpath}sched/${functions.getFieldValue(myitems, i, 'order_doc')}' class='infobutt custbtn' target=_blank  rel='noopener noreferrer'>Order Document</a></div>`
          }
          if (functions.getFieldValue(myitems, i, 'charges_doc') !== '') {
            conterz += `<div><a href='${docpath}sched/${functions.getFieldValue(myitems, i, 'charges_doc')}' class='infobutt custbtn' target=_blank  rel='noopener noreferrer'>Rates and Charges</a></div>`
          }
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'polyname')}</span></div>`
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'poly_info')}</span></div>`
          /**
           * check the tariff node
           * append the correct text
           */
          var _tariff = functions.getFieldValue(myitems, i, 'tariff') + functions.getFieldValue(myitems, i, 'tariff1') + functions.getFieldValue(myitems, i, 'tariff2')
          if (_tariff !== '') {
            conterz += `<div><span>Tariff: ${_tariff.split(': :').join('<br>').split(':').join('')}</span></div>`
          }

          conterz += `<div><span>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)})</span></div>`
          infoms = ''
        }
        /**
         * check if the node is a zone address
         */

        else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
          /**
           * check if the length of the result is more than 1
           */

          if (myitemsLength > 1) {
            /**
             * add the property name to infolink
             * this will be use in the list that display all the selected restrictions
             */

            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`
          }

          /**
           * append the property name
           * append the street name
           * append the Data correct at time of publication (date) text
           * assign blank value to infoms, no document allowed in this node
           */

          conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'property')}</span></div>`
          conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'street')}</span></div>`
          conterz += `<div><span>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)})</span></div>`
          infoms = ''
        }

        /**
         * copy button
         */

        conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="Copy content to clipboard"></button>`

        /**
         * check if is the first iteration, first result or not
         * append the correct div to the popup content
         */

        if (i === 0) {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel'>${infoms}${conterz}</div>`
        }
        else {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel' style='display:none;'>${infoms}${conterz}</div>`
        }

        /**
         * reset the conterz var as now is inside the infoDiv var
         */

        conterz = ''
      } // next feature

    /**
     * finish nottingham popup
     */
    }

    /**
     * hackney popup
     */

    else if (popupname === 'hackney') {
      /**
       * iterate through the result
       */

      for (let i = 0; i <= (myitemsLength - 1); i++) {
        /**
         * check if the length of the result is more than 1
         */

        if (myitemsLength > 1) {
          /**
           * add the restriction name and the street name to infolink
           * this will be use in the list that display all the selected restrictions
           */
          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
        }

        /**
         * check for the additonalinfo value
         */

          /**
           * get the additonalinfo value
           * append it to the popup content
           */

          if (parseInt($('#addinfo').val()) > 0) {
            conterz = conterz + `<div><a class='infobutt custbtn' target=_blank rel='noopener noreferrer' href='/additionalinformation/${pageconfig.config_id}/0'>${popupconfig.parkmap_popup.addinfo}</a></div>`
          }


        /**
         * store the ms_grid and order_ref in a hidden input
         */

        conterz += `<input id='msgrid_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'ms_grid')}'/>`
        conterz += `<input id='orderref_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'order_ref')}'/>`
        // add hidden entry_type to check for geom
        conterz += `<input id='entry_type_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'entry_type')}'/>`
        /**
         * check the times_of_enforcement value
         * append the correct text
         */

        if (functions.getFieldValue(myitems, i, 'times_of_enforcement') !== '(None)') {
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'times_of_enforcement')}</span></div>`
        }

        /**
         * append the pre_description value
         * append the post_description value
         * append the tariff value
         */

        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'pre_description')}</span></div>`
        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'post_description')}</span></div>`
        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'tariff') + functions.getFieldValue(myitems, i, 'tariff1') + functions.getFieldValue(myitems, i, 'tariff2')}</span></div>`

        /**
         * get the from/to date
         * append the correct text
         */

        dfrom = (myitems[i].getElementsByTagName('date_from')[0].firstChild.nodeValue).split('-').reverse().join('/')
        dto = (myitems[i].getElementsByTagName('date_to')[0].firstChild.nodeValue).split('-').reverse().join('/')

        if (dto !== undefined && dto !== '01/01/2199' && dto !== '') {
          conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.dateto}${dto}</span></div>`
        }
        else {
          conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.presentday}</span></div>`
        }

        /**
         * append the Data correct at time of publication (date) text
         */

        conterz += `<div><span>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)})</span></div>`

        /**
         * get the blockimagefile value
         * check for the presence of gif or pdf in the name
         * append the correct text
         */

        if (myitems[i].getElementsByTagName('blockimagefile')[0].childNodes.length !== 0) {
          sSignFile = functions.getFieldValue(myitems, i, 'blockimagefile')
          iGif = -1
          iPdf = -1
          iGif = sSignFile.indexOf('.gif')
          iPdf = sSignFile.indexOf('.pdf')

          if (iGif !== -1) {
            conterz += `<div>img src='images/signs/${sSignFile}'/></div>`
          }
          if (iPdf !== -1) {
            conterz += `<div><a href='data/parkmap/pdfs/${sSignFile}' target=_blank rel='noopener noreferrer'>${popupconfig.parkmap_popup.pdf}</a></div>`
          }
        }

        /**
         * append the view documents button
         * it will be populate at the end of the function
         */

        infoms = `<div style='display:none' id='docstore_${i}'><button class='infobutt custbtn' id='docbutton_${i}'>${popupconfig.parkmap_popup.viewdocuments}</button><div id='docdiv_${i}' style='display:none'></div></div>`

        /**
         * append the order_ref value
         * append the street_name value
         */

        conterz += `<div><span class='infotitle'>${functions.getFieldValue(myitems, i, 'order_ref')}&nbsp</span>`
        conterz += `<span class='infotitle'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`

        /**
         * copy button
         */

        conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="${popupconfig.copystate}"></button>`

        /**
         * check if is the first iteration, first result or not
         * append the correct div to the popup content
         */

        if (i === 0) {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel'>${infoms}${conterz}</div>`
        }
        else {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel' style='display:none;'>${infoms}${conterz}</div>`
        }
        /**
         * reset the conterz var as now is inside the infoDiv var
         */

        conterz = ''
      } // next feature

      /**
       * finish hackney popup
       */
    }

    /**
     * standard popup
     */

    else {
      /**
       * iterate through the result
       */

      for (let i = 0; i <= (myitemsLength - 1); i++) {
        const itemtype = myitems[i].attributes.getNamedItem('type').nodeValue

        /**
         * check if the node is Confirmed or Proposed
         */

        if (itemtype === 'Confirmed' || itemtype === 'proplayer') {
          const pbays = functions.getFieldValue(myitems, i, 'pbays')

          /**
           * manchester shows the template title as the heading
           * and prefixes the list item with Proposed: or Confirmed:
           */

          let itemtitle = popupname === 'manchester' ? functions.getFieldValue(myitems, i, 'title') : ''
          let itemprefix = ''
          if (itemtitle !== '') {
            itemprefix = itemtype === 'proplayer' ? popupconfig.hover_popup.proposed : popupconfig.hover_popup.confirmed
          }

          /**
           * check if the length of the result is more than 1
           */

          if (myitemsLength > 1) {
            /**
             * add the restriction name and the street name to infolink
             * this will be use in the list that display all the selected restrictions
             */
             if (lang !== 'en') {
              infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${itemprefix}${functions.getFieldValue(myitems, i, 'restriction_ln')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
            } else {
              infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${itemprefix}${functions.getFieldValue(myitems, i, 'restriction')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
            }
          }

            /**
             * get the additonalinfo value
             * append it to the popup content
             */

            if (parseInt($('#addinfo').val()) > 0) {
                conterz = conterz + `<div><a class='infobutt custbtn' target='_blank' rel='noopener noreferrer' href='/additionalinformation/${pageconfig.config_id}/0'>${popupconfig.parkmap_popup.addinfo}</a></div>`

            }
          /**
           * store the ms_grid and order_ref in a hidden input
           */

          conterz += `<input id='msgrid_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'ms_grid')}'/>`
          conterz += `<input id='orderref_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'order_ref')}'/>`
          // add hidden entry_type to check for geom
          conterz += `<input id='entry_type_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'entry_type')}'/>`
          /**
           * check if it's not the enfield popup
           * check for the schedule value
           */

          if (popupname !== 'enfield' && popupname !== 'devon') {
            if (functions.getFieldValue(myitems, i, 'schedule') !== '') {
              /**
               * append the order_ref value
               */

              conterz += `<div class='infotitle infotab'><span>${functions.getFieldValue(myitems, i, 'order_ref')}&nbsp</span>`

              /**
               * check the popup name
               */

              if (popupname === 'cumbria' || popupname === 'dorset' || popupname === 'northampton') {
                /**
                 * append the schedule value with a float class
                 */

                conterz += `<span class='custflotitle'>${popupconfig.parkmap_popup.schedule}${functions.getFieldValue(myitems, i, 'schedule')}</span></div>`
              }
              /**
               * else if standard popup
               */
              else {
                /**
                 * append the schedule value with no float class
                 */

                conterz += `<span> ${popupconfig.parkmap_popup.schedule}${functions.getFieldValue(myitems, i, 'schedule')}</span></div>`
              }
            }

            /**
             * else if schedule value is empty
             */

            else {
              /**
               * append the order_ref value
               */

              conterz += `<div class='infotitle infotab'><span>${functions.getFieldValue(myitems, i, 'order_ref')}&nbsp</span>`

              /**
               * check the popup name
               */

              if (popupname === 'cumbria' || popupname === 'dorset' || popupname === 'northampton' || popupname === 'stoke') {
                /**
                 * append the strret_name value with a float class
                 */

                conterz += `<span class='custflotitle'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
              }

              /**
               * else if standard popup
               */

              else {
                /**
                 * append the street_name value with no float class
                 */
                if (functions.getFieldValue(myitems, i, 'street_name').toLowerCase().indexOf('zone') >= -1) {
                    conterz += `<span>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
                } else {
                    conterz += `<span class='street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
                }
                
              }

              /**
               * end check schedule value
               * end if (popupname !== 'enfield')
               */
            }
          }

          /**
           * append restriction value
           */
          if (popupname === 'devon') {
            // staff or private site
            conterz += `<div class='infotitle infotab'><span>${functions.getFieldValue(myitems, i, 'order_ref')}&nbsp</span></div>`
          }
          if (lang !== 'en') {
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'restriction_ln')}</span></div>`
          } else {
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'restriction')}</span></div>`
          }

          if (popupname === 'devon' && pageconfig.private) {
            //  site only
            conterz += `<div><span class='infotitle'> ${popupconfig.parkmap_popup.schedule}${functions.getFieldValue(myitems, i, 'schedule')}</span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class='infotitle'> ${popupconfig.parkmap_popup.length}${functions.getFieldValue(myitems, i, 'length')}</span></div>`
          }
          if (popupname === 'devon') {
            let side = functions.getFieldValue(myitems, i, 'side_of_road')
            if (side !== '') {
              side = side.charAt(0).toUpperCase() + side.substring(1)
            }
            conterz += `<div><span>${functions.getFieldValue(myitems, i, 'street_name')} ${functions.getFieldValue(myitems, i, 'district')}</span></div>`
            conterz += `<div><span>${popupconfig.parkmap_popup.sideofroad}${side}</span></div>`
          }
          if (popupname === 'devon' && pageconfig.private) {
            if (pbays !== '0' && pbays !== '') {
              conterz += `<div><span class='infotitle'>${popupconfig.parkmap_popup.numberofbays}</span><span>${pbays}</span></div>`
            }

            if (functions.getFieldValue(myitems, i, 'ordstart') !== '') {
              conterz += `<div><span>${functions.getFieldValue(myitems, i, 'ordstart')} ${functions.getFieldValue(myitems, i, 'ordfinish')}</span></div>`
            }
            conterz += `<div class='spacer'></div>`
          }
          /**
           * build the street line, with the district if there is one
           * manchester shows it before the start/end description, everyone else after the dates
           */

          let streetline = ''
          if (popupname !== 'devon') {
            if (myitems[i].getElementsByTagName('district')[0].childNodes.length !== 0) {
              streetline = `<div><span>${functions.getFieldValue(myitems, i, 'street_name')}, ${functions.getFieldValue(myitems, i, 'district')}</span></div>`
            }
            else {
              streetline = `<div><span class='street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
            }
          }

          /**
           * check if popup is bexley
           */
          if (window.location.href.indexOf('bexley') > -1 && pageconfig.private === false) {
            /**
             * append a space div
             */

            conterz += `<div class='spacer'></div>`
          }
          else {
            /**
             * append a space div
             */

            conterz += `<div class='spacer'></div>`

            if (popupname === 'manchester') {
              conterz += streetline
            }

            /**
             * check if the restriction is a region or a point
             */

            if (functions.getFieldValue(myitems, i, 'entry_type') === 'Region' || functions.getFieldValue(myitems, i, 'entry_type') === 'Point') {
              /**
               * check the ordlocation value
               */

              if (functions.getFieldValue(myitems, i, 'ordlocation') !== '') {
                /**
                 * append the ordlocation
                 */

                conterz += `<div><span>${functions.getFieldValue(myitems, i, 'ordlocation')}</span></div>`
              }
            }

            /**
             * if is a line restriction
             */

            else {
              /**
               * check the ordstart value
               * if is not empty append the ordstart and ordfinish value
               */

              if (functions.getFieldValue(myitems, i, 'ordstart') !== '' && popupname !== 'devon') {
                conterz += `<div><span>${functions.getFieldValue(myitems, i, 'ordstart')} ${functions.getFieldValue(myitems, i, 'ordfinish')}</span></div>`
              }
            }

            /**
             * manchester shows the number of bays for parking places
             */

            if (popupname === 'manchester' && pbays !== '0' && pbays !== '') {
              conterz += `<div><span class='infotitle'>${popupconfig.parkmap_popup.numberofbays}</span><span>${pbays}</span></div>`
            }

            /**
             * check the tariff value
             * if is not empty append the tariff value
             */
            var _tariff = functions.getFieldValue(myitems, i, 'tariff') + functions.getFieldValue(myitems, i, 'tariff1') + functions.getFieldValue(myitems, i, 'tariff2')
            if (_tariff !== '') {
              conterz += `<div><span class='infotitle'>${popupconfig.parkmap_popup.tariff}</span><span>${_tariff.split(': :').join('<br>').split(':').join('')}</span></div>`
            }

            /**
             * check the pcode value
             * if is not empty append the pcode value with tariff code text and a link to the document
             */

            if (functions.getFieldValue(myitems, i, 'pcode') !== '') {
              conterz += `<div><a href='${docpath}sched/FeesandCharges.pdf' class='infonav' target=_blank  rel='noopener noreferrer'>${popupconfig.parkmap_popup.tariffcode}${functions.getFieldValue(myitems, i, 'pcode')}</a></div>`
            }

            /**
             * check the pbp code value
             * if is not empty append the pbp value
             */

            if (functions.getFieldValue(myitems, i, 'pbp_code') !== '') {
              conterz += `<div><span class='infonav'>${popupconfig.parkmap_popup.pbpcode}${functions.getFieldValue(myitems, i, 'pbp_code')}</span></div>`
            }

            /**
             * ende if/else bexley popup
             */
          }

          /**
           * get the from/to date
           * append the correct text
           * proposed orders are not in effect yet so they have no effective date
           */

          if (popupname !== 'enfield' && itemtype !== 'proplayer') {
            dfrom = (myitems[i].getElementsByTagName('date_from')[0].firstChild.nodeValue).split('-').reverse().join('/')
            dto = (myitems[i].getElementsByTagName('date_to')[0].firstChild.nodeValue).split('-').reverse().join('/')

            if (dto !== undefined && dto !== '01/01/2199' && dto !== '') {
              conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.dateto}${dto}</span></div>`
            }
            else {
              conterz += `<div><span>${popupconfig.parkmap_popup.datefrom}${dfrom}${popupconfig.parkmap_popup.presentday}</span></div>`
            }
          }

          /**
           * append the street line, manchester already has it above the start/end description
           */
          if (popupname !== 'manchester') {
            conterz += streetline
          }
          /**
           * append the Data correct at time of publication (date) text
           */
          conterz += `<div><span>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)})</span></div>`
          const zoom = view.getView().getZoom()
          var zoom1

          if(!Number.isInteger(zoom)){
            zoom1 = Math.round(zoom);
          }else {
            zoom1 = zoom
          }
          var windowurl = window.location.href;
          let theDate = $('#activedate').val().split('/').join('-')
          var urlindex  = windowurl.indexOf("?")

          if (urlindex != -1) {
            windowurl = windowurl.substring(0, windowurl.indexOf('?'));
            coord =`<div class="url" style='display:none;'>
            <span>${popupconfig.consult_popup.datastate} <time>${functions.getPublishDate(pageconfig.appname.type)}</time></span>
            <span> ${popupconfig.parkmap_popup.activedate}${theDate}<br /></span>
            <span> ${popupconfig.parkmap_popup.copydate}${today}<br /></span>
            <span>${windowurl}${'?markpos='}${mousePos},${zoom1}<br />
            </span></div>`


          }else{

            coord = `<div class="url" style='display:none;'>
            <span>${popupconfig.consult_popup.datastate} <time>${functions.getPublishDate(pageconfig.appname.type)}</time></span>
            <span> ${popupconfig.parkmap_popup.activedate}${theDate}<br /></span>
            <span> ${popupconfig.parkmap_popup.copydate}${today}<br /></span>
            <span>${window.location.href}${'?markpos='}${mousePos},${zoom1}<br /></span></div>`
          }
          conterz += coord



          /**
           * get the blockimagefile value
           * check for the presence of gif or pdf in the name
           * append the correct text
           */

          if (myitems[i].getElementsByTagName('blockimagefile')[0].childNodes.length !== 0) {
            sSignFile = functions.getFieldValue(myitems, i, 'blockimagefile')
            iGif = -1
            iPdf = -1
            iGif = sSignFile.indexOf('.gif')
            iPdf = sSignFile.indexOf('.pdf')

            if (iGif !== -1) {
              conterz += `<div><img src='${docpath}signs/${sSignFile}'/></div>`
            }
            if (iPdf !== -1) {
              conterz += `<div><a href='${docpath}signs/${sSignFile}' target=_blank  rel='noopener noreferrer'${popupconfig.parkmap_popup.pdf}</a></div>`
            }
          }

          /**
           * append the view documents button
           * it will be populate at the end of the function
           */

          infoms = `<div style='display:none' id='docstore_${i}'><button class='infobutt custbtn' id='docbutton_${i}'>${popupconfig.parkmap_popup.viewdocuments}</button><div id='docdiv_${i}' style='display:none'></div></div>`

          /**
           * put the title heading above everything else, including the documents button
           */

          if (itemtitle !== '') {
            infoms = `<div class='infotitle'><span>${itemtitle}</span></div>` + infoms
          }

          /**
           * end check if the node is Confirmed or Proposed
           */
        }

        /**
         * check if the node is tariff zones or parking zones
         */

        else if (itemtype === 'Tariff Zones' || itemtype === 'Parking Zones') {
          /**
           * check if the length of the result is more than 1
           */

          if (myitemsLength > 1) {
            /**
             * add the restriction name and the street name to infolink
             * this will be use in the list that display all the selected restrictions
             */

            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'polyname')}</li>`
          }

          /**
           * append the polygon name
           * append the polygon info
           * tariff rates and charges
           */
          if (functions.getFieldValue(myitems, i, 'order_doc') !== '') {
            conterz += `<div><a href='${docpath}sched/${functions.getFieldValue(myitems, i, 'order_doc')}' class='infobutt custbtn' target=_blank  rel='noopener noreferrer'>Order Document</a></div>`
          }
          if (functions.getFieldValue(myitems, i, 'charges_doc') !== '') {
            conterz += `<div><a href='${docpath}sched/${functions.getFieldValue(myitems, i, 'charges_doc')}' class='infobutt custbtn' target=_blank  rel='noopener noreferrer'>Rates and Charges</a></div>`
          }
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'polyname')}</span></div>`
          conterz += `<div><span>${functions.getFieldValue(myitems, i, 'poly_info')}</span></div>`
          var _tariff = functions.getFieldValue(myitems, i, 'tariff') + functions.getFieldValue(myitems, i, 'tariff1') + functions.getFieldValue(myitems, i, 'tariff2')
          if (_tariff !== '') {
            conterz += `<div><span>Tariff: ${_tariff.split(': :').join('<br>').split(':').join('')}</span></div>`
          }
          /**
           * append the zonecode value plus the text
           */

          conterz += `<div><span> ${popupconfig.parkmap_popup.zonecode}${functions.getFieldValue(myitems, i, 'zonecode')}</span></div>`

          /**
           * append the Data correct at time of publication (date) text
           * assign blank value to infoms, no document allowed in this node
           */

          conterz += `<div><span>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)})</span></div>`

          infoms = ''

          /**
           * end tariff zones or parking zones node
           */
        }

        /**
         * check if the node is zone address
         */

        else if (itemtype === 'Zone Address') {
          /**
           * check if the length of the result is more than 1
           */

          if (myitemsLength > 1) {
            /**
             * add the property name to infolink
             * this will be use in the list that display all the selected restrictions
             */

            infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`
          }

          /**
           * append the property name
           * append the strret name
           * append the Data correct at time of publication (date) text
           * assign blank value to infoms, no document allowed in this node
           */
          if (functions.getFieldValue(myitems, i, 'addresstype') == 1) {
              conterz += `<div><span class='accsize infotitle'>Non-qualifying Address</span></div>`
          } else {
              conterz += `<div><span class='accsize infotitle'>Qualifying Address</span></div>`
          }
          conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'property')}</span></div>`
          conterz += `<div><span class='accsize'>${functions.getFieldValue(myitems, i, 'street')}</span></div>`
          conterz += `<div><span>${popupconfig.consult_popup.datastate} (${functions.getPublishDate(pageconfig.appname.type)}</span></div>`

          infoms = ''
        } else if (itemtype === 'streetlight') {
            if (myitemsLength > 1) {
                infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'zonename')}</li>`
            }
            if (myitems[i].getElementsByTagName('speed')[0].childNodes.length !== 0) {
                conterz += `<span class='infotitle'>Area: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('zonename')[0].firstChild.nodeValue}</span></span><span class='infotitle'> Speed: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('speed')[0].firstChild.nodeValue}</span></span>`
            } else {
                conterz += `<span class='infotitle'>Area: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('zonename')[0].firstChild.nodeValue}</span></span><span> Sign</span>`
            }
            conterz += `<div><span>${popupconfig.consult_popup.datastate} (<time>${functions.getPublishDate(pageconfig.appname.type)}<time>)</span></div>`

        }

        /**
         * copy button
         */

        conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="${popupconfig.copystate}"></button>`

        /**
         * check if is the first iteration, first result or not
         * append the correct div to the popup content
         */

        if (i === 0) {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel'>${infoms}${conterz}</div>`
        }
        else {
          infoDiv = infoDiv + `<div id='info_${i}' class='info-panel' style='display:none;'>${infoms}${conterz}</div>`
        }
        /**
         * reset the conterz var as now is inside the infoDiv var
         */

        conterz = ''
      } // next feature

      /**
       * end standard popup
       */
    }
  }

  /**
   * common code for all popups
   */

  /**
   * check if the length of the result is more than 1
   */

  if (myitemsLength > 1) {
    /**
     * create the infolink variable
     *  - this is the button that display the list of all the selected restrictions
     * merge and assing infolink plus infoDiv to the content of the popup
     */

    infolink = `<div><button id='itembutton' class='custbtn'></button><div id='itemdiv' style='display:none'><ul id='itemlist'>${infolink}</ul></div></div>`
    conterz = infolink + infoDiv + `<input type='hidden' id='numofdivs' value='${myitemsLength}'/>`
  }

  /**
   * if the length of the result is 1
   */

  else {
    /**
     * assing infoDiv to the content of the popup
     */

    conterz = infoDiv
  }

  /**
   * check for the screen resolution
   */

  if (functions.mobileTabletView()) {
    /**
     * if is mobile append the content of the popup to the modal used for the popup
     * display the modal
     */

    // deepcode ignore DOMXSS: <please specify a reason of ignoring this>
    modalpop.innerHTML = conterz
    $('#mobpopup').modal('show')
  }

  /**
   * if is a tablet or a pc append the content of the popup to the popup div
   * display the popup
   */

  else {
    // deepcode ignore DOMXSS: <please specify a reason of ignoring this>
    content.innerHTML = conterz
  }

  /**
   * check for maps and schedules documents
   * we need to pass the mouse position, popupname
   */

  getMapSchedsAndDocs('0', mousePos)

  getNearestStreet('0', mousePos)

  /**
   * if you click on multiple restrictions show all the available restrictions
   */

  setInfoControls(overlay, popupname)

  /**
   * check if it's a fra staff website
   * run the correct functions
   */

  if (appname === 'fra' && pageconfig.private) {
    frabutton.editActionField()
    frabutton.fraDeleteItem(overlay)
    frabutton.fraUpdateStatus()
  }

  /**
   * check if it's a psa staff website
   * run the correct functions
   */

  if (appname === 'psa' && pageconfig.private) {
    psabutton.psaDeleteItem(overlay)
  }

  /**
   * end fullInfo function
   */
}

/**
 * get the maps and schedules documents through a php file request
 */

const getMapSchedsAndDocs = (sInfoDiv, mousePosition) => {
  /**
   * check for the length of msgrid_0 in the popup
   */


  if ($(`#msgrid_${sInfoDiv}`).length === 0 || $('#doclist_' + sInfoDiv).length) {
    return
  }

  /**
   * get the orderref_
   * get the msgrid_
   * the slice split join is becase in the database the value is stored as ,1, instead of just the number 1
   * get the date from the datepicker and change it in postgres format
   */

  let orderref = document.getElementById(`orderref_${sInfoDiv}`).value
  let theGrid = document.getElementById(`msgrid_${sInfoDiv}`).value
  theGrid = theGrid.slice(1, -1)
  theGrid = theGrid.split(',').join(",") //clean up grid as comma sep numbers
  let theDate = $('#activedate').val().split('/').reverse().join('-')
  let theData = '{"ref": "'+ orderref +'","date": "'+ theDate +'", "grid": "'+ theGrid +'", "e": ' + parseInt(mousePosition[0]) + ', "n": ' + parseInt(mousePosition[1]) + '}'

  // if docstore_sinfodiv already exisitngs then return!
  if ($('#doclist_' + sInfoDiv).length) {
        return
  }

  /**
   * get the json for mapscheds and docs
   */
   $.ajax({
    url: '/mapschedsanddocs',
    type:"POST",
    data: {
      jdata: theData
    },
    beforeSend: function beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
    },
    success:function(data){
      /**
       * parse the result
       */

       data = JSON.parse(data)

       /**
        * if no result return
        */

       if (typeof data.documents === 'undefined' && typeof data.mapscheds === 'undefined') {
         return
       }

       /**
        * if there are result:
        *  - display the docstore_ div
        */

       $(`#docstore_${sInfoDiv}`).css('display', 'block')

       /**
        * docbutton_ click event listener
        */

       $(`#docbutton_${sInfoDiv}`).click(() => {
         $(`#docdiv_${sInfoDiv}`).slideToggle()
       })

       /**
        * create the doclist_ list and the hidden list with the links
        */

       let theDocList = $("<ul id='doclist_" + sInfoDiv + "' class='doclist'></ul>")
       // style='display:none;'
       let theHiddenList = $("<ul id='dochiddenlist_"+ sInfoDiv + "' class='doclisthidden'  style='display:none;' ></ul>")

       /**
        * check the value of data.documents
        */

       if (typeof data.documents !== 'undefined') {
         /**
          * for each data.documents
          */

         $.each(data.documents, function () {
           /**
            * asign to orderDocs this the one you pass through
            */

           let orderDocs = this

           /**
            * create the li element for the orderDocs
            * add the click event listener
            * open the document in a new windows
            */

           let theDocItem = $(`<li>${orderDocs.doc_category}</li>`).attr({tabindex: '0', role: 'button'}).attr('doctype', 'document').attr('docname', orderDocs.doc_name).click(function () {
             let theDoc = `${$(this).attr('docname')}`
             window.open(theDoc)
           })


          let theHiddenItem = $(`<li>${orderDocs.doc_name}</li>`).attr('doctype', 'document').attr('docname', orderDocs.doc_name).click(function () {
            let thehiddenDoc =  `${$(this).attr('docname')}`
            window.open(thehiddenDoc)
          })

           /**
            * append the li element to the list
            */

           theDocList.append(theDocItem)

           theHiddenList.append(theHiddenItem)

           /**
            * end for each
            * end if (typeof data.documents !== 'undefined')
            */
         })
       }

       /**
        * check the value of data.mapscheds
        */

       if (typeof data.mapscheds !== 'undefined') {
         /**
          * for each data.mapscheds
          */

         $.each(data.mapscheds, function () {
           /**
            * asign to mapScheds this the one you pass through
            */

           let mapScheds = this

           /**
            * create the li element for the mapScheds
            * add the click event listener
            * open the document in a new windows
            */

           let theMapItem = $(`<li class='resetgrid grid_${mapScheds.grid}'>${popupconfig.parkmap_popup.schedule}${mapScheds.tile_num}</li>`).attr({tabindex: '0', role: 'button'}).attr('docname', mapScheds.doc_name).attr('doctype', 'mapsched').attr('grid', mapScheds.grid).click(function () {
             let theDoc = `${$(this).attr('docname')}`
             window.open(theDoc)
           })


           let theHiddenMapItem = $(`<li>${mapScheds.doc_name}</li>`).attr('docname', mapScheds.doc_name).attr('doctype', 'mapsched').attr('grid', mapScheds.grid).click(function () {
            let theHiddenMapDoc = `${mapScheds.grid}${$(this).attr('docname')}`
            window.open(theHiddenMapDoc)
          })
           /**
            * append the li element to the list
            */

           theDocList.append(theMapItem)
           theHiddenList.append(theHiddenMapItem)

           /**
            * end for each
            * end if (typeof data.documents !== 'undefined')
            */
         })
       }

       /**
        * append the li element to the list
        */

       let theDocDiv = $(`#docdiv_${sInfoDiv}`)
       theDocDiv.append(theDocList)
       theDocDiv.append(theHiddenList)

       /**
        * end done Ajax
        */
    },
   })

  /**
   * end getMapSchedsAndDocs
   */
}

/**
 * if you click on multiple restrictions show all the available restrictions
 */

const setInfoControls = (getOverlay, popupname) => {
  /**
   * initialize the overlay
   */

  let overlay = getOverlay
  /**
   * get the text from the listitem_0
   * change the text of itembutton
   * prepend the arrow to the text
   */

  const theButt = $('#listitem_0').text()

  $('#itembutton').text(theButt)
  $('#itembutton').prepend("<em class='itmbtnlist fas fa-caret-right' aria-hidden='true'></em>")
  $('#itembutton').attr({'aria-expanded': 'false', 'aria-controls': 'itemdiv'})

  /**
   * make the list items reachable and operable by keyboard
   * enter/space is handled by the delegated keydown in common/popup.js
   */

  $('.itemlist').attr({tabindex: '0', role: 'button'})

  /**
   * itembutton click event listener
   */

  $('#itembutton').click(function () {
    /**
     * show/hide the list of available restrictions
     * change the arrow accordingly
     */

    $('#itemdiv').slideToggle()
    $(this).children('em').toggleClass('fa-caret-right fa-caret-down')
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true')
  })

  /**
   * itemlist click event listener
   */

  $('.itemlist').click(function (e) {
    /**
     * prevent default behaviour
     */

    e.preventDefault()

    /**
     * get the value from the this item
     * get the text from the listitem_
     * change the text of itembutton
     * prepend the arrow to the text
     * show/hide the list of available restrictions
     */

    let theVal = this.value
    const theButts = $(`#listitem_${theVal}`).text()
    $('#itembutton').text(theButts)
    $('#itembutton').prepend("<em class='itmbtnlist fas fa-caret-right' aria-hidden='true'></em>")
    $('#itembutton').attr('aria-expanded', 'false')
    $('#itemdiv').slideToggle()

    /**
     * change the displayed popup content
     */

    changeInfoItem(theVal, overlay.getPosition())

    /**
     * end itemlist click event listener
     */
  })

  /**
   * if the popupname is nottingham
   */

  if (popupname === 'nottingham') {
    /**
     * exCodeBtn click event listener
     */

    $('.exCodeBtn').button().click(function (e) {
      /**
       * prevent default behaviour
       */

      e.preventDefault()

      /**
       * get the value of the clicked button
       * get the id of the button splitting by _
       * change the text of exDesc_
       */

      let theVal = this.value
      let sSpanID = this.id.split('_')[1]
      $('#exDesc_' + sSpanID).text(theVal)

      /**
       * check the oldval attribute of exDesc_
       */

      /**
       * if the oldval attribute is 'none'
       */

      if ($(`#exDesc_${sSpanID}`).attr('oldval') === 'none') {
        /**
         * this happen the first time
         * change the oldval attribute
         * show/hide the current exDesc_
         * return, prevent to continue
         */

        $(`#exDesc_${sSpanID}`).attr('oldval', theVal)
        $(`#exDesc_${sSpanID}`).toggle()
        return
      }

      /**
       * if the oldval attribute is === to the actual val
       */

      if ($(`#exDesc_${sSpanID}`).attr('oldval') === theVal) {
        /**
         * this happen if you click on the same button
         * show/hide the current exDesc_
         */

        $(`#exDesc_${sSpanID}`).toggle()
      }

      /**
       * if the oldval attribute is !== to the actual val
       */

      else {
        /**
         * this happen when you click on another button
         * change the oldval attribute
         * show the new exDesc_
         */

        $(`#exDesc_${sSpanID}`).attr('oldval', theVal)
        $(`#exDesc_${sSpanID}`).css('display', 'block')
      }
    })

    /**
     * end if the popupname is nottingham
     */
  }

  /**
   * end setInfoControls
   */
}

/**
 * change the displayed popup content
 */

const changeInfoItem = (sInfoDiv, coordinate) => {
  /**
   * initialize numofdivs
   * change the numofdivs to the number of element inside numofdivs
   * assign to num the lenght of numofdivs - 1 to itemLength
   */

  let numofdivs = 0
  numofdivs = parseInt(document.getElementById('numofdivs').value)
  let itemLength = numofdivs - 1

  /**
   * initialize numofdivs
   * change the numofdivs to the number of element inside numofdivs
   * assign to num the lenght of numofdivs - 1 to itemLength
   */

  for (let l = 0; l <= itemLength; l++) {
    /**
     * check if #info_ l match info_ sInfoDiv
     */

    if (document.getElementById(`info_${l}`).id === (`info_${sInfoDiv}`)) {
      /**
       * display info_ sInfoDiv
       */

      $(`#info_${sInfoDiv}`).css('display', 'block')

      /**
       * move focus to the displayed item so screen readers announce the change
       * the list that had focus is being hidden
       */

      $(`#info_${sInfoDiv}`).attr('tabindex', '-1')[0].focus({preventScroll: true})
      restrObjected = $('#restr_' + l).text()

      try {
        let myitems = gXML.getElementsByTagName('item')
        pm_id = functions.getFieldValue(myitems, l, 'pm_id')
      } catch (error) { }

    }
    /**
     * if #info_ l don't match info_ sInfoDiv
     */

    else {
      /**
       * hide info_ l
       */

      $(`#info_${l}`).css('display', 'none')
    }

    /**
     * end for loop
     */
  }

  /**
   * check for maps sched and documents of the new displayed element
   */
//console.log(coordClick)
  getNearestStreet(sInfoDiv, coordClick)
  getMapSchedsAndDocs(sInfoDiv, coordClick)

  /**
   * end const changeInfoItem = (sInfoDiv, coordinate) =>
   */
}

/**
 * public consultation popup
 */

const fullInfoPc = (xml,mousePos, getOverlay) => {
  /**
   * assign the popupname value
   * assign the overlay value
   */

  gXML = xml
  coordClick = mousePos
  let layerinfo = functions.altFind(pageconfig.layers, function(e) {return e.layers === "consult"})
  let popupname = layerinfo.popupname
  let overlay = getOverlay

  /**
   * get the result from the XML
   * - create a parser
   * - parse the result
   * - get the item element
   * - get the length of the item element
   */

  let myitems = xml.getElementsByTagName('item')
  let myitemsLength = myitems.length

  /**
   * initilaize some variable to use it in the process
   */

  let conterz = ''
  let infolink = ''
  let infoDiv = ''
  schemeObjected
  streetObjected = 'N/A'
  let popupSchemeId = ''
  let proposeditem = -1
  /**
   * get the popup container
   *  - normal popup
   *  - mobile popup
   */

  let content = document.getElementById('popup-content')
  let modalpop = document.getElementById('mobpopupbody')

  /* find proposed item - if > 1 items make it the default selection */
  for (let i = 0; i <= (myitemsLength - 1); i++) {
    if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Proposed') {
        proposeditem = i
        break
    }
  }
  /**
   * iterate through the result
   */

  for (let i = 0; i <= (myitemsLength - 1); i++) {
  /**
   * check if the node is sign
   * if it's return
   */

    /**
     * check if the length of the result is more than 1
     */

    if (myitemsLength > 1) {
      if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
        infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'polyname')}</li>`
      }  else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
        infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`
      } else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'streetlight') {
        infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'zonename')}</li>`
      } else {
        if (lang !== 'en') {
          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction_ln')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
        } else {
          infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'restriction')} ${functions.getFieldValue(myitems, i, 'street_name')}</li>`
        }
       }
    }

    /**
     * check if the node is proposed
     */

    if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Proposed') {

      /**
       * set the consultation var to pass into the form
       */


      if (functions.getFieldValue(myitems, i, 'street_name') !== '') {
        streetObjected = functions.getFieldValue(myitems, i, 'street_name')
      }
      try {
        if (functions.getFieldValue(myitems, i, 'pm_id') !== '') {
          pm_id = functions.getFieldValue(myitems, i, 'pm_id')
        }
      } catch (error) {
        console.log('Error: PMID missing from template')
      }
      if (i === 0) {
        if (lang !== 'en') {
          restrObjected = functions.getFieldValue(myitems, i, 'restriction_ln')
        } else {
          restrObjected = functions.getFieldValue(myitems, i, 'restriction')
        }

      }
      /**
       * append the deposited document
       * check if order_doc is not blank
       *  - set the url based on dev environment or live
       *  - send a get request in async mode
       *  - if the file exist append the Deposited Document button (based on dev environment or live)
       *  - if the file doesn't exist append the Deposited Document button with the class d-none
       * if the file doesn't exist append the Deposited Document button with the class d-none
       * we still append the button because there is a function attached to it, if is not present it will fail
       */

      if (functions.getFieldValue(myitems, i, 'order_doc') !== '') {
            /**
             * get the deposited Document
             */

        let schDoc = '/documents/consult/' + encodeURIComponent(functions.getFieldValue(myitems, i, 'order_doc'))
        conterz += `<div><span><a href="${$('#docstore').val()}${schDoc}" class='infobutt custbtn' target='_blank' rel='noopener noreferrer'>${popupconfig.consult_popup.deposited}</a></span></div>`
      }

      
      /**
       * append the send a comment with it's function
       */
       popupSchemeId = functions.getFieldValue(myitems, i, 'scheme_id')
       let consulttype = $('#schemehead_' + popupSchemeId).attr('data-schemetypes')
      if (consulttype.indexOf('1,') !== -1) {
        conterz += `<div><span><button class='infobutt custbtn itemcomment'>${popupconfig.consult_popup.comment}</button></span></div>`
      }

      /**
       * check the addinfo node
       */

        if (parseInt($('#addinfo').val()) > 0) {
            conterz = conterz + `<div><a class='infobutt custbtn' target='_blank' rel='noopener noreferrer' href='/additionalinformation/${pageconfig.config_id}/0'>${popupconfig.consult_popup.addinfo}</a></div>`
            conterz += `<div class='spacer' style='clear:both;font-size:xx-small;'>&nbsp;</div>`
        }

      if (functions.getFieldValue(myitems, i, 'docpath') !== '') {
            /**
             * get the tariff Document
             */

        let feeDoc = '/documents/consult/' + encodeURIComponent(functions.getFieldValue(myitems, i, 'docpath'))
        conterz += `<div><span><a href="${$('#docstore').val()}${feeDoc}" class='infonav' target='_blank' rel='noopener noreferrer'>Fees and Charges</a></span></div>`
      }
      
      /**
       * append the scheme name plus the street name
       * append the restriction name
       * add a space
       */

      schemeObjected = $('#schemehead_' + popupSchemeId).attr('data-schemename')

      // add hidden entry_type to check for geom
      conterz += `<input id='entry_type_${i}' type='hidden' value='${functions.getFieldValue(myitems, i, 'entry_type')}'/>`

      conterz += `<div class='infotitle'><span class='pcTitle'>${schemeObjected}</span><span class='pcTitle street_name_${i}'> ${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`

      if (lang !== 'en') {
        conterz += `<div><span id='restr_${i}'>${functions.getFieldValue(myitems, i, 'restriction_ln')}</span></div>`
      } else {
        conterz += `<div><span id='restr_${i}'>${functions.getFieldValue(myitems, i, 'restriction')}</span></div>`
      }
      conterz += `<div class='spacer' style='clear:both;font-size:xx-small;'>&nbsp;</div>`

      /**
       * check the tariff node
       * append the correct text
       */
      var _tariff = functions.getFieldValue(myitems, i, 'tariff') + functions.getFieldValue(myitems, i, 'tariff1') + functions.getFieldValue(myitems, i, 'tariff2')
      if (_tariff !== '') {
        conterz += `<div><span class='infotitle'>${popupconfig.parkmap_popup.tariff}</span><span>${_tariff.split(': :').join('<br>').split(':').join('')}</span></div>`
      }


      /**
       * check the pcode node
       * append the correct text
       */

      if (functions.getFieldValue(myitems, i, 'pcode') !== '') {
        conterz += `<div><a href='${$('#docstore').val()}/sched/FeesandCharges.pdf' class='infonav'>${popupconfig.consult_popup.tariffcode}${functions.getFieldValue(myitems, i, 'pcode')}</a></div>`
      }

      /**
       * check the pbp_code node
       * append the correct text
       */

      if (functions.getFieldValue(myitems, i, 'pbp_code') !== '') {
        conterz += `<div><span class='infonav'>${popupconfig.consult_popup.pbpcode}${functions.getFieldValue(myitems, i, 'pbp_code')}</span></div>`
      }

      /**
       * get the from / to date
       * append the correct text
       */

      let dfrom = (myitems[i].getElementsByTagName('date_advert')[0].firstChild.nodeValue).split('-').reverse().join('/')
      let dto = (myitems[i].getElementsByTagName('date_close')[0].firstChild.nodeValue).split('-').reverse().join('/')

      if (dto !== undefined && dto !== '01/01/2199' && dto !== '') {
        conterz += `<div><span>${popupconfig.consult_popup.advertfrom}${dfrom}${popupconfig.consult_popup.advertto}${dto}</span></div>`
      }
      else {
        conterz += `<div><span>${popupconfig.consult_popup.advertfrom}${dfrom}${popupconfig.consult_popup.presentday}</span></div>`
      }

      conterz += `<div><span class='street_name_${i}'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
      conterz += `<div><span>${popupconfig.consult_popup.ref}${functions.getFieldValue(myitems, i, 'order_ref')}</span></div>`

      /** add moving orders traffex photos */
      if (popupname === 'move') {
        if (myitems[i].getElementsByTagName('times_of_enforcement')[0].childNodes.length !== 0) {
            let camphotos = functions.getFieldValue(myitems, i, 'times_of_enforcement').split(',')
            if (camphotos[0] !== '') {
                conterz += `<div class='photoBox' style="max-height:250px;overflow-y:auto;" >`
              camphotos.forEach(element => {
                let photo = '/documents/consult/' + encodeURIComponent(element)
                conterz += `<div class='popPhoto' style="display:inline;padding:2px;" ><a href="${$('#docstore').val()}${photo}" target='_blank' rel='noopener noreferrer'><img src="${$('#docstore').val()}${photo}" onerror="this.style.display='none'"></a></div>`
              })
              conterz += `</div>`
            }
        }
      }
      /**
       * check the blockimagefile field
       */

      if (myitems[i].getElementsByTagName('blockimagefile')[0].childNodes.length !== 0) {
        /**
         * get the blockimagefile value
         * check for the presence of gif or pdf in the name
         * append the correct text
         */

        let sSignFile = functions.getFieldValue(myitems, i, 'blockimagefile')
        let iGif = -1
        let iPdf = -1
        iGif = sSignFile.indexOf('.gif')
        iPdf = sSignFile.indexOf('.pdf')

        if (iGif !== -1) {
          conterz += `<div><img src='${docpath}signs/${sSignFile}'/></div>`
        }
        if (iPdf !== -1) {
          conterz += `<div><a href='${docpath}signs/${sSignFile}' target=_blank  rel='noopener noreferrer'>${popupconfig.consult_popup.pdf}</a></div>`
        }
      }

      /**
       * append the Data correct at time of publication (date) text
       */

      conterz += `<div><span>${popupconfig.consult_popup.datastate} (<time>${functions.getPublishDate(pageconfig.appname.type)}<time>)</span></div>`

    /**
     * end check if the node is proposed
     */
    }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Parking Zones' || myitems[i].attributes.getNamedItem('type').nodeValue === 'Tariff Zones') {
    /**
     * if it's a confirmed order
     */
     conterz += `<div class='infotitle'><span>${popupconfig.consult_popup.existingorder}</span></div>`
     conterz += `<div class='infotitle'><span class='accsize'>${functions.getFieldValue(myitems, i, 'polyname')}</span></div>`
    }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'Zone Address') {
      /**
       * check if the length of the result is more than 1
       */

         infolink = infolink + `<li value='${i}' class='itemlist resetorder order_${i}' id='listitem_${i}'>${functions.getFieldValue(myitems, i, 'property')}</li>`
    }
    else if (myitems[i].attributes.getNamedItem('type').nodeValue === 'streetlight') {
      conterz += `<span class='infotitle'>Area: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('zonename')[0].firstChild.nodeValue}</span></span><span class='infotitle'> Speed: <span class='infotitle_norm'>${myitems[i].getElementsByTagName('speed')[0].firstChild.nodeValue}</span></span>`
      conterz += `<div><span>${popupconfig.consult_popup.datastate} (<time>${functions.getPublishDate(pageconfig.appname.type)}<time>)</span></div>`
    }
     else {
    /**
     * append Existing Order text
     * append street name
     * append restriction name
     * append Data correct at time of publication (date) text
     */

      conterz += `<div class='infotitle'><span>${popupconfig.consult_popup.existingorder}</span></div>`
      conterz += `<div class='infotitle'><span class='street_name_${i}' class='accsize'>${functions.getFieldValue(myitems, i, 'street_name')}</span></div>`
      if (lang !== 'en') {
        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'restriction_ln')}</span></div>`
      } else {
        conterz += `<div><span>${functions.getFieldValue(myitems, i, 'restriction')}</span></div>`
      }

      conterz += `<div><span>${popupconfig.consult_popup.datastate} (<time>${functions.getPublishDate(pageconfig.appname.type)}<time>)</span></div>`
    }

    /**
     * copy button
     */

    conterz += `<button id='Copy_Btn_${i}' class='Copy_Btn btn mt-1 fas fa-clipboard' style='width:auto;' data-toggle="tooltip" data-container="#Copy_Btn_${i}" data-placement="top" title="${popupconfig.copystate}"></button>`

    /**
     * check if is the first iteration, first result or not
     * append the correct div to the popup content - if a proposed item is in a multi list - make it the default selection
     */
    if (proposeditem > -1) {
        if (i === proposeditem) {
            infoDiv += `<div id='info_${i}' class='info-panel'>${conterz}</div>`
        }
        else {
            infoDiv += `<div id='info_${i}' class='info-panel' style='display:none;'>${conterz}</div>`
        }
    } else {
        if (i === 0) {
        infoDiv += `<div id='info_${i}' class='info-panel'>${conterz}</div>`
        }
        else {
        infoDiv += `<div id='info_${i}' class='info-panel' style='display:none;'>${conterz}</div>`
        }
    }
    /**
     * reset the conterz var as now is inside the infoDiv var
     */

    conterz = ''
  } // next feature

  /**
   * check if the length of the result is more than 1
   */

  if (myitemsLength > 1) {
    /**
     * create the infolink variable
     *  - this is the button that display the list of all the selected restrictions
     * merge and assing infolink plus infoDiv to the content of the popup
     */

    infolink = `<div><button id='itembutton' class='custbtn'></button><div id='itemdiv' style='display:none'><ul id='itemlist'>${infolink}</ul></div></div>`
    conterz = infolink + infoDiv + `<input type='hidden' id='numofdivs' value='${myitemsLength}'/>`
  }
  /**
   * if the length of the result is 1
   */

  else {
    /**
     * assing infoDiv to the content of the popup
     */

    conterz = infoDiv
  }

  /**
   * check for the screen resolution
   */

  if (functions.mobileTabletView()) {
    /**
     * if is mobile append the content of the popup to the modal used for the popup
     * display the modal
     */

    modalpop.innerHTML = conterz
    $('#mobpopup').modal('show')
  }
  /**
   * if is a tablet or a pc append the content of the popup to the popup div
   * display the modal
   */

  else  {
    content.innerHTML = conterz
  }

  /**
   * if you click on multiple restrictions show all the available restrictions
   */
  getNearestStreet('0', coordClick)
  setInfoControls(overlay, popupname)

  if (proposeditem > -1) {
    let buttText = $(`#listitem_${proposeditem}`).text()
    $('#itembutton').text(buttText)
    $('#itembutton').prepend("<em class='itmbtnlist fas fa-caret-right'></em>")
  }
  /**
   * pc send comment click event listener
   */

  $('.itemcomment').on('click', () => {
    //console.log('street objected:')
    //console.log(streetObjected)
    pccomment.consultInit(popupSchemeId,schemeObjected,'N/A',0, streetObjected, restrObjected, pm_id, '1')
  })

  /**
   * end fullInfoPc
   */
}

/**
 * Returns street name from nearest property.
 * For Regions with multiple streets, restrict to 
 * speed restrictions for now
 */

const getNearestStreet = (sInfoDiv, coordClick) => {
//console.log('getNearestStreet')

//return if no entry_type
if (!$(`#entry_type_${sInfoDiv}`)) {return}

let permittedTypes = ['10 MPH','20 MPH','30 MPH','40 MPH','50 MPH','60 MPH','NATIONAL SPEED LIMIT','20 MPH ZONE','40 MPH ZONE']
if ($(`#entry_type_${sInfoDiv}`).val() !== 'Region' && permittedTypes.indexOf(restrObjected.toUpperCase()) == -1) {
  return ''
}

/**
 * get the coords
 */

let type = 'georef';
let dataString = `coordx=${parseInt(coordClick[0])}&coordy=${parseInt(coordClick[1])}&limit=1&epsg=27700`

dataString += `&type=` + type

/**
 * get the json for nearest street
 */
  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: '/find-address',
    data: dataString,
    beforeSend: function beforeSend(xhr) {
    xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'))
    }
  })
    .done((data) => {
      /**
       * create the result list
       */
      $.each(data.distance, function () {
        const place = this
        //console.log(place.street_name)
        $(`.street_name_${sInfoDiv}`).text(place.street_name)
        streetObjected = place.street_name
        return place.street_name
      })
    })
    /**
     * show the reason why doesn't work on fail
     */

    .fail((jqxhr, textStatus, error) => {
      let err = `${textStatus} , ${error}`
      alert(`findNearestStreet Request Failed: ${err}`)
      return ''
    })
    .always(() => {
      /**
       * hide the loading bar
       * reenable the search button
       */

      $('.loading').hide()
    })


 /**
 * end getNearestStreet
 */
}



/**
 * EXPORT
 */

export default {
  getExemptions,
  fullInfoPc,
  fullInfo,
}
